var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TableColumns",class:{ isMobile: !_vm.screenSizes.includes(_vm.pagination.tableBreakpoint) }},_vm._l((_vm.pagination.dataColumns),function(ref,index){
var label = ref.label;
var style = ref.style;
return _c('div',{key:index,staticClass:"cell",style:(style)},[_c('h4',{staticClass:"columnLabel"},[_vm._v(" "+_vm._s(label)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }